import LabelTableCell from 'Components/LabelTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import { useAuthorityContext } from 'Services/common/Features/Authority/Context/authorityContext'
import {
  getAuthorityIdFromProductId,
  getProductNameById
} from 'Services/SalesManagement/Features/TicketSale/ticketSaleProductInfo'
import type { BulkTicketSale } from 'Services/SalesManagement/Features/TicketSale/types'
import { datetimeFormatterWithoutSeconds } from 'Util/formatters'
import { Paper, Table, TableBody, TableCell, TableContainer } from '@mui/material'
import { styled } from '@mui/material/styles'
import { t } from 'ttag'

interface BulkTicketSaleDetailsProps {
  bulkTicketSale: BulkTicketSale
}

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

export default function BulkTicketSaleDetails({
  bulkTicketSale
}: Readonly<BulkTicketSaleDetailsProps>) {
  const { getAuthorityNameByCode } = useAuthorityContext()

  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Details table`}>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>{t`Event identifier`}</StyledTableCell>
            <TableCell>{bulkTicketSale.event_identification}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Product`}</StyledTableCell>
            <TableCell>{getProductNameById(bulkTicketSale.external_product_id)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Authority`}</StyledTableCell>
            <TableCell>
              {getAuthorityNameByCode(
                getAuthorityIdFromProductId(bulkTicketSale.external_product_id)
              )}
            </TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Zone`}</StyledTableCell>
            <TableCell>
              {bulkTicketSale.external_zone_from_name} - {bulkTicketSale.external_zone_to_name}
            </TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Ticket quantity`}</StyledTableCell>
            <TableCell>{bulkTicketSale.total_requested_quantity}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Active tickets`}</StyledTableCell>
            <TableCell>{bulkTicketSale.total_processed_count}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Cancelled tickets`}</StyledTableCell>
            <TableCell>{bulkTicketSale.total_cancelled_count}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Valid from`}</StyledTableCell>
            <TableCell>{datetimeFormatterWithoutSeconds(bulkTicketSale.valid_from)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Valid to`}</StyledTableCell>
            <TableCell>{datetimeFormatterWithoutSeconds(bulkTicketSale.valid_to)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Created`}</StyledTableCell>
            <TableCell>{datetimeFormatterWithoutSeconds(bulkTicketSale.created)}</TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
